import * as complaintStore from "@/store/api/complaint/complaint.js";
import * as complaintGroupStore from "@/store/api/complaint/complaintGroup.js";
import * as screeningStore from "@/store/api/screening/screening.js";
import * as deplistStore from "@/store/api/deplist/index.js";
import * as officerStore from "@/store/api/officer/index.js";
import * as provinceStore from "@/store/api/province/index.js";
import * as trackingNullStore from "@/store/api/complaintManage/trackingNull.js";
import * as legalStore from "@/store/api/legal/index.js"

const searchAdapter = (vueInstance, params) => {
  console.log("searchAdapter called");

  vueInstance.$emit("handleOverlay", true);

  let searchMethod = getSearchMethod(vueInstance.searchMode);

  searchMethod(params)
    .then(function(response) {
      if (response.data.success) {
        vueInstance.rows = response.data.data;
        try {
          vueInstance.totalRecords = response.data.data[0].totalCount;
        } catch (ex) {
          console.log("get total records error", ex);
          vueInstance.totalRecords = 0;
        }
      } else {
        vueInstance.rows = [];
        vueInstance.totalRecords = 0;
      }
    })
    .catch(function(error) {
      console.log("error", error);
    })
    .then(function() {
      vueInstance.$emit("handleOverlay", false);
      vueInstance.getExportPages();
    });
};

const getSearchMethod = (searchMode) => {
  let searchMethod;

  console.log('searchMode', searchMode)

  if (searchMode === "SearchAll") {
    searchMethod = screeningStore.GetComplaintForSearch;
  } else if (searchMode === "History") {
    searchMethod = screeningStore.GetComplaintForHistorySearch;
  } else if (searchMode === "UserHistory") {
    searchMethod = screeningStore.GetComplaintForUserHistorySearch;
  } else if (searchMode === "ScreeningHistory") {
    searchMethod = screeningStore.getComplaintScreeningHistory;
  } else if (searchMode === "Screening") {
    searchMethod = screeningStore.getComplaintForDivision;
  } else if (
    searchMode === "Deptlist" ||
    searchMode === "LawDeptlist" ||
    searchMode === "DeptlistHistory" ||
    searchMode === "LawDeptlistHistory"
  ) {
    searchMethod = deplistStore.getComplaintForAdminDept;
  } else if (searchMode === "Officer" || searchMode === "LawOfficer") {
    searchMethod = officerStore.getComplaintForUser;
  } else if (searchMode === 'Province') {
    searchMethod = provinceStore.getComplaintForProvince
  } else if (searchMode === 'TrackingNull') {
    searchMethod = trackingNullStore
    .GetComplaintTrackingNull
  } else if (searchMode === 'LawLeaderDept') {
    searchMethod = legalStore.getComplaintForLeaderLegal
  } else if (searchMode === 'ScreeningGroup') { // จัดกลุ่มเรื่องร้องทุกข์เมนู Screening
    searchMethod = complaintGroupStore.getComplaintForScreening
  } else if (searchMode === 'UserGroup') { // จัดกลุ่มเรื่องร้องทุกข์เมนู Officer / LawOfficer
    searchMethod = complaintGroupStore.getComplaintForUser
  }else if (searchMode === 'Bangkok'){ /* หน้ารายการเจ้าหน้าที่กทม. */
    searchMethod = provinceStore.getComplaintForBangkok
  }else if (searchMode === 'UserBangkokHistory'){ /* หน้าประวัติเจ้าหน้าที่กทม. */
    searchMethod = provinceStore.GetComplaintForBangkokHistorySearch
  }

  return searchMethod;
};

export  {searchAdapter, getSearchMethod};
